















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class HomeList extends Vue {
  get list() {
    return this.$store.state.homeList;
  }

  private toProduct(id: string) {
    // this.$router.push({ path: 'goods', query: { gid: id }});
    // this.$router.push('/goods/'+id);
    this.$router.push({ name: 'goods', params: { id }});
  }
}
